const STORAGE_KEY = 'tp_pending_room_code';

export function savePendingRoomCode(roomCode: string): void {
  const normalized = String(roomCode || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  if (!normalized) return;
  sessionStorage.setItem(STORAGE_KEY, normalized);
}

export function readPendingRoomCode(): string | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  return raw ? raw.toUpperCase() : null;
}

export function clearPendingRoomCode(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function extractRoomCodeFromSearch(search: string): string | null {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const code = params.get('roomCode');
  if (!code) return null;
  const normalized = code.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
  return normalized || null;
}
